const isValidUrl = (url) => {
    try {
        const urlObject = new URL(url);

        return !!urlObject;
    } catch (e) {
        return false;
    }
};

const getQueryParams = (url) => new URLSearchParams(window.location.search.replace(/\/$/, ''));

export default {
    isValidUrl,
    getQueryParams,
};
